import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { trackEvent } from "@/lib/audit";

export function OfflineBanner() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const update = () => {
      const off = !navigator.onLine;
      setOffline((prev) => {
        if (prev !== off) {
          void trackEvent(off ? "offline_mode_detected" : "online_mode_restored", {});
        }
        return off;
      });
    };
    update();
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);

  if (!offline) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[9997] bg-amber-600/95 text-white text-[11px] font-bold tracking-wide">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-3 py-1.5">
        <WifiOff className="h-3.5 w-3.5" />
        <span>Modo offline — los datos en vivo se reanudarán automáticamente al volver la conexión.</span>
      </div>
    </div>
  );
}